<script lang="ts" setup>
import type { IconStyleType } from '@/api/interfaces'

interface Props {
  iconStyle: IconStyleType
}

defineProps<Props>()
</script>

<template>
  <svg
    v-if="iconStyle === 'isometric'"
    xmlns="http://www.w3.org/2000/svg"
    width="136"
    height="116"
    viewBox="0 0 136 116"
    fill="none"
  >
    <g id="icon">
      <path
        d="M71.5273 11.5151C58.3989 26.667 59.011 53.0873 72.0531 68.1456C85.0952 83.204 112.984 82.0732 126.113 66.9213C139.233 51.7694 139.304 27.2753 126.262 12.217C113.22 -2.84134 84.6479 -3.63676 71.5273 11.5151Z"
        fill="#3E3F61"
      />
      <path
        d="M71.182 12.3885C58.0537 27.5404 57.9909 52.0346 71.0329 67.0929C84.075 82.1512 105.286 82.0732 118.414 66.9213C131.543 51.7694 131.606 27.2753 118.563 12.217C105.521 -2.84134 84.3104 -2.76336 71.182 12.3885Z"
        fill="#4C5086"
      />
      <path
        d="M76.4632 18.4867C66.2775 30.2464 66.2226 49.2584 76.3455 60.9479C86.4684 72.6374 102.932 72.575 113.125 60.8153C123.311 49.0556 123.366 30.0437 113.243 18.3542C103.12 6.66466 86.6567 6.72705 76.4632 18.4867Z"
        fill="#E2E6F2"
      />
      <path
        d="M82.0426 24.9283C74.9565 33.1164 74.9173 46.3421 81.9641 54.4757C89.0109 62.6092 100.46 62.5702 107.554 54.3821C114.64 46.2018 114.679 32.9682 107.632 24.8347C100.586 16.7012 89.1364 16.7402 82.0426 24.9283Z"
        fill="#4C5086"
      />
      <path
        d="M87.6768 31.4323C83.7218 36.0021 83.6982 43.387 87.6297 47.9255C91.5611 52.4641 97.9566 52.4407 101.912 47.8709C105.867 43.3012 105.89 35.9163 101.959 31.3777C98.0272 26.8392 91.6318 26.8626 87.6768 31.4323Z"
        fill="#E2E6F2"
      />
      <path
        d="M91.3337 35.6584C89.4111 37.8808 89.4033 41.468 91.3101 43.6749C93.2249 45.8818 96.3324 45.8662 98.2549 43.6515C100.177 41.429 100.185 37.8419 98.2785 35.635C96.3637 33.4281 93.2562 33.4359 91.3337 35.6584Z"
        fill="#4C5086"
      />
      <path
        d="M92.4087 36.8984C91.0825 38.4268 91.0747 40.8989 92.393 42.4195C93.7113 43.9402 95.8536 43.9324 97.1798 42.4039C98.506 40.8755 98.5138 38.4035 97.1955 36.8828C95.8772 35.3622 93.7349 35.3699 92.4087 36.8984Z"
        fill="#3E3F61"
      />
      <path
        d="M81.046 49.6713L82.1603 50.5447L83.0314 44.2749L81.9092 43.4093L81.046 49.6713Z"
        fill="#FCC156"
      />
      <path
        d="M82.9764 35.7443L84.0907 36.6177L94.5432 38.9961L93.4289 38.1305L82.9764 35.7443Z"
        fill="#FCC156"
      />
      <path
        d="M82.1054 42.014L83.2197 42.8796L84.0907 36.6177L82.9764 35.7443L82.1054 42.014Z"
        fill="#FCC156"
      />
      <path
        d="M16.4478 68.3641L17.5699 69.2297L83.2197 42.8796L82.1054 42.014L16.4478 68.3641Z"
        fill="#FCC156"
      />
      <path
        d="M11.3314 75.5457L12.4457 76.4113L15.4904 71.4126L14.3761 70.547L11.3314 75.5457Z"
        fill="#FCC156"
      />
      <path
        d="M3.97854 81.4339L5.09284 82.3073L12.2652 72.7077L11.1509 71.8421L3.97854 81.4339Z"
        fill="#FCC156"
      />
      <path
        d="M12.6027 66.3673L13.717 67.2329L17.5699 69.2297L16.4478 68.3641L12.6027 66.3673Z"
        fill="#FCC156"
      />
      <path
        d="M12.6027 66.3673L14.2506 69.2449L15.3649 70.1183L13.717 67.2329L12.6027 66.3673Z"
        fill="#FCC156"
      />
      <path d="M0 83.1261L1.1143 83.9995L8.012 73.9242L6.8977 73.0508L0 83.1261Z" fill="#FCC156" />
      <path
        d="M6.1208 66.0243L7.2351 66.8899L15.3649 70.1183L14.2506 69.2449L6.1208 66.0243Z"
        fill="#FCC156"
      />
      <path
        d="M6.1208 66.0243L11.0018 70.5473L12.1161 71.4207L7.2351 66.8899L6.1208 66.0243Z"
        fill="#FCC156"
      />
      <path
        d="M2.16577 67.5148L6.8977 73.0508L8.012 73.9242L3.28008 68.3882L2.16577 67.5148Z"
        fill="#FCC156"
      />
      <path
        d="M2.16577 67.5148L3.28008 68.3882L12.1161 71.4207L11.0018 70.5473L2.16577 67.5148Z"
        fill="#FCC156"
      />
      <path
        d="M83.2197 42.8796L17.5699 69.2297L13.717 67.2329L15.3649 70.1183L7.2351 66.8899L12.1161 71.4207L3.28009 68.3872L8.012 73.9242L1.1143 83.9995L12.2652 72.7077L5.09284 82.3073L15.4904 71.4126L12.4457 76.4113L17.6954 70.5005L83.0314 44.2749L82.1603 50.5447L94.5432 38.9961L84.0907 36.6177L83.2197 42.8796Z"
        fill="#FB8E05"
      />
      <path
        d="M83.871 45.8037L83.8867 52.128L85.1187 52.8376L85.103 46.5133L83.871 45.8037Z"
        fill="#FCC156"
      />
      <path
        d="M83.8474 38.0675L85.0794 38.7772L95.7673 39.6895L94.5353 38.9799L83.8474 38.0675Z"
        fill="#FCC156"
      />
      <path
        d="M83.8474 38.0675L83.871 44.3919L85.0951 45.1015L85.0794 38.7772L83.8474 38.0675Z"
        fill="#FCC156"
      />
      <path
        d="M22.545 79.5771L23.777 80.2867L85.0951 45.1015L83.871 44.3919L22.545 79.5771Z"
        fill="#FCC156"
      />
      <path
        d="M18.4802 87.3985L19.7122 88.1081L22.0272 82.7352L20.7952 82.0255L18.4802 87.3985Z"
        fill="#FCC156"
      />
      <path
        d="M12.0298 94.2533L13.2618 94.9629L19.0059 84.4666L17.7818 83.7569L12.0298 94.2533Z"
        fill="#FCC156"
      />
      <path
        d="M18.4567 78.1271L19.6808 78.8367L23.777 80.2867L22.545 79.5771L18.4567 78.1271Z"
        fill="#FCC156"
      />
      <path
        d="M18.4567 78.1271L20.4891 80.7551L21.7211 81.4647L19.6808 78.8367L18.4567 78.1271Z"
        fill="#FCC156"
      />
      <path
        d="M8.32589 96.476L9.55006 97.1856L14.9725 86.2526L13.7405 85.5429L8.32589 96.476Z"
        fill="#FCC156"
      />
      <path
        d="M11.9905 78.6886L13.2146 79.3982L21.7211 81.4647L20.4891 80.7551L11.9905 78.6886Z"
        fill="#FCC156"
      />
      <path
        d="M11.9905 78.6886L17.46 82.4941L18.6841 83.2038L13.2146 79.3982L11.9905 78.6886Z"
        fill="#FCC156"
      />
      <path
        d="M8.27881 80.7161L13.7405 85.5429L14.9725 86.2526L9.51082 81.4258L8.27881 80.7161Z"
        fill="#FCC156"
      />
      <path
        d="M8.27881 80.7161L9.51082 81.4258L18.6841 83.2038L17.46 82.4941L8.27881 80.7161Z"
        fill="#FCC156"
      />
      <path
        d="M85.0951 45.1015L23.777 80.2867L19.6808 78.8367L21.7211 81.4647L13.2146 79.3982L18.6841 83.2038L9.51082 81.4258L14.9725 86.2526L9.55006 97.1856L19.0059 84.4666L13.2618 94.9629L22.0272 82.7352L19.7122 88.1081L24.0831 81.5194L85.103 46.5133L85.1187 52.8376L95.7673 39.6895L85.0794 38.7772L85.0951 45.1015Z"
        fill="#FB8E05"
      />
      <path
        d="M87.8181 47.4415L89.4111 53.5631L90.7765 53.9452L89.1835 47.8236L87.8181 47.4415Z"
        fill="#FCC156"
      />
      <path
        d="M85.8641 39.9549L87.2296 40.337L97.8076 38.5902L96.4422 38.2003L85.8641 39.9549Z"
        fill="#FCC156"
      />
      <path
        d="M85.8641 39.9549L87.4571 46.0768L88.8225 46.4589L87.2296 40.337L85.8641 39.9549Z"
        fill="#FCC156"
      />
      <path
        d="M36.8348 95.2753L38.2002 95.6574L88.8225 46.4589L87.4571 46.0768L36.8348 95.2753Z"
        fill="#FCC156"
      />
      <path
        d="M34.8494 103.846L36.2149 104.236L37.1173 98.4573L35.7519 98.0752L34.8494 103.846Z"
        fill="#FCC156"
      />
      <path
        d="M30.3059 112.08L31.6713 112.463L34.6219 100.882L33.2643 100.492L30.3059 112.08Z"
        fill="#FCC156"
      />
      <path
        d="M32.511 94.8781L33.8764 95.2602L38.2002 95.6574L36.8348 95.2753L32.511 94.8781Z"
        fill="#FCC156"
      />
      <path
        d="M32.511 94.8781L35.1319 96.9212L36.4974 97.3033L33.8764 95.2602L32.511 94.8781Z"
        fill="#FCC156"
      />
      <path
        d="M27.2769 115.145L28.6423 115.527L31.1613 103.604L29.7959 103.222L27.2769 115.145Z"
        fill="#FCC156"
      />
      <path
        d="M26.3823 97.0146L27.7477 97.3967L36.4974 97.3033L35.1319 96.9212L26.3823 97.0146Z"
        fill="#FCC156"
      />
      <path
        d="M26.3823 97.0146L32.6287 99.3542L33.9941 99.7442L27.7477 97.3967L26.3823 97.0146Z"
        fill="#FCC156"
      />
      <path
        d="M23.2983 99.8917L29.7959 103.222L31.1613 103.604L24.6637 100.282L23.2983 99.8917Z"
        fill="#FCC156"
      />
      <path
        d="M23.2983 99.8917L24.6637 100.282L33.9941 99.7442L32.6287 99.3542L23.2983 99.8917Z"
        fill="#FCC156"
      />
      <path
        d="M88.8225 46.4589L38.2002 95.6574L33.8764 95.2602L36.4974 97.3033L27.7477 97.3967L33.9941 99.7442L24.6637 100.282L31.1613 103.604L28.6423 115.527L34.6219 100.882L31.6713 112.463L37.1173 98.4573L36.2149 104.236L38.8044 96.7801L89.1835 47.8236L90.7765 53.9452L97.8076 38.5902L87.2296 40.337L88.8225 46.4589Z"
        fill="#FB8E05"
      />
    </g>
  </svg>
  <svg
    v-else
    xmlns="http://www.w3.org/2000/svg"
    width="110"
    height="111"
    viewBox="0 0 110 111"
    fill="none"
  >
    <g id="Vector">
      <path
        d="M93.8909 94.7424C115.37 73.2636 115.37 38.4395 93.8909 16.9607C72.412 -4.51815 37.588 -4.51815 16.1091 16.9607C-5.36971 38.4395 -5.36971 73.2636 16.1091 94.7424C37.588 116.221 72.412 116.221 93.8909 94.7424Z"
        fill="black"
      />
      <path
        d="M83.7386 90.9011C103.096 75.0288 105.922 46.4692 90.0494 27.1115C74.1771 7.75383 45.6175 4.92837 26.2598 20.8007C6.90213 36.673 4.07668 65.2326 19.949 84.5903C35.8213 103.948 64.3809 106.773 83.7386 90.9011Z"
        fill="#F3F6F9"
      />
      <path
        d="M86.0212 70.8334C94.2975 53.6977 87.1156 33.0972 69.98 24.8209C52.8443 16.5446 32.2438 23.7265 23.9675 40.8621C15.6912 57.9978 22.8731 78.5983 40.0087 86.8746C57.1444 95.1509 77.7449 87.969 86.0212 70.8334Z"
        fill="black"
      />
      <path
        d="M54.9984 79.0998C67.838 79.0998 78.2466 68.6912 78.2466 55.8516C78.2466 43.0119 67.838 32.6033 54.9984 32.6033C42.1588 32.6033 31.7502 43.0119 31.7502 55.8516C31.7502 68.6912 42.1588 79.0998 54.9984 79.0998Z"
        fill="#F3F6F9"
      />
      <path
        d="M67.0906 55.8516C67.0906 49.1684 61.6816 43.7594 54.9984 43.7594C48.3152 43.7594 42.9062 49.1684 42.9062 55.8516C42.9062 62.5348 48.3152 67.9438 54.9984 67.9438C61.6816 67.9438 67.0906 62.5348 67.0906 55.8516Z"
        fill="black"
      />
      <path
        d="M90.4168 17.7546L89.5977 12.5797L99.4275 1.21563V8.2239L106.878 6.75463L95.3577 18.8598L90.4168 17.7546Z"
        fill="#E27A7A"
      />
      <path
        d="M60.0563 47.6601L68.8979 38.3894L90.7549 15.1152C90.9759 14.8811 91.34 14.8811 91.5741 15.1022L92.8613 16.3634C93.1083 16.6104 93.1213 17.0005 92.8743 17.2475L62.3577 49.8055L60.0563 47.6601Z"
        fill="#7A164D"
      />
      <path
        d="M61.4866 48.4792L58.6261 42.2771L52.879 58.309L68.9889 52.0159L61.4866 48.4792Z"
        fill="#E27A7A"
      />
    </g>
  </svg>
</template>
